import { ActionContext, ActionTree } from 'vuex'
import { mutationType } from './mutation-types'
import UserState, {IUserList} from './states'
import _ from 'lodash'
import { State } from '@/store/store'
import axios from 'axios'
import httpRequest from '../../../../services/HttpRequestServiceWithToken'

const actions: ActionTree<UserState, State> = {
  async getUserList(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: object,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'user', options, (res: IUserList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async editUser(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options._id
    delete options._id
    await httpRequest
      .putByLevel(
        process.env.VUE_APP_API_URL + '/v1', `user/${id}`,
        options, (res: object) => {
          // someting
        },
      )
  },
  async getUserListByRoleCaregiver(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'user/role/' + id, options, (res: IUserList) => {
        commit(mutationType.GET_LIST_CAREGIVER, res)
      })
  },
  async getUserListByRoleLeader(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'user/role/' + id, options, (res: IUserList) => {
        commit(mutationType.GET_LIST_LEADER, res)
      })
  },
  async getUserListByRoleCaregiverAndUser(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .get(process.env.VUE_APP_API_URL + '/v1/user/role/' + id, options, (res: IUserList) => {
        commit(mutationType.GET_LIST_CAREGIVER, res)
      })
  },

  async getUserListByRoleId(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', `user/role/` + id, options, (res: IUserList) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
  async getStaffList(
    { commit, dispatch, state }: ActionContext<UserState, State>,
    options: {[key: string]: any},
  ): Promise<void> {
    const id = options.id
    delete options.id
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1', 'staff', options, (res: IUserList) => {
        commit(mutationType.GET_LIST_STAFF, res)
      })
  },
  async getUserListByLevel(
    { commit, dispatch, state }: ActionContext<UserState, State>,
  ): Promise<void> {
    await httpRequest
      .getByLevel(process.env.VUE_APP_API_URL + '/v1',
        'user/list/all'
        , {},
        (res: any) => {
        commit(mutationType.GET_LISTS, res)
      })
  },
}

export default actions
